import React, { useEffect, useState } from "react";
import { Card, CardHeader, Divider, Image } from "@nextui-org/react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@nextui-org/react";
import {
  collection,
  getDocs,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { format } from "date-fns";

type RoomParams = {
  id: string;
};

type infoSolicitarPresenca = {
  sessao: {
    id: string;
    dataSessao: string;
    legislatura: string;
    periodo: string;
    sessao: string;
    statusConfigSessao: number;
    statusSessao: string;
    tipoSessao: string;
  };
};

const ORDEM_MESA_DIRETORA: Record<string, number> = {
  presidente: 0,
  "vice-presidente": 1,
  "1-secretário": 2,
  "2-secretário": 3,
};

const LABEL_MESA_DIRETORA: Record<string, string> = {
  presidente: "PRESI:",
  "vice-presidente": "VICE:",
  "1-secretário": "1º SEC:",
  "2-secretário": "2º SEC:",
};

export function SolicitarPresenca({ sessao }: infoSolicitarPresenca) {
  const params = useParams<RoomParams>();
  const roomId = params.id;

  const [presencaParlamentares, setPresencaParlamentares] = useState([]);
  const [primeiraParte, setPrimeiraParte] = useState([]);
  const [segundaParte, setSegundaParte] = useState([]);
  const [mesaDiretora, setMesaDiretora] = useState([]);
  const [funcaoPorId, setFuncaoPorId] = useState<Record<string, string>>({});

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "presencaParlamentares"
    );

    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          id: doc.id,
          ...data,
        };
      });

      //@ts-ignore
      setPresencaParlamentares(parsedData);
    });
  }, []);

  useEffect(() => {
    const db = getFirestore();

    const parlamentaresRef = collection(
      db,
      "users",
      "belacruz@eleg",
      "parlamentares"
    );
    const queryRef = query(
      parlamentaresRef,
      where("parlamentarEstado", "==", "ativo")
    );

    getDocs(queryRef).then((querySnapshot) => {
      const funcoes: Record<string, string> = {};
      querySnapshot.docs.forEach((doc) => {
        funcoes[doc.id] = doc.data().funcaoPartidaria;
      });
      setFuncaoPorId(funcoes);
    });
  }, []);

  useEffect(() => {
    const presentesAtivos = presencaParlamentares
      //@ts-ignore
      .filter((item) => funcaoPorId[item.id] !== undefined);

    const primeiraParteArray = presentesAtivos
      //@ts-ignore
      .filter((item) => ORDEM_MESA_DIRETORA[funcaoPorId[item.id]] === undefined)
      .slice(0, 2);
    const segundaParteArray = presentesAtivos
      //@ts-ignore
      .filter((item) => ORDEM_MESA_DIRETORA[funcaoPorId[item.id]] === undefined)
      .slice(2);
    setPrimeiraParte(primeiraParteArray);
    setSegundaParte(segundaParteArray);

    setMesaDiretora(
      presentesAtivos
        //@ts-ignore
        .filter((item) => ORDEM_MESA_DIRETORA[funcaoPorId[item.id]] !== undefined)
    );
  }, [presencaParlamentares, funcaoPorId]);

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col justify-between p-0 bg-gray-900">
      <div>
        <Card className="min-w-[100%] h-22 items-center bg-gray-900 p-0 ">
          <CardHeader className="flex flex-col items-center">
            <h1 className="text-5xl font-extrabold  uppercase text-gray-50">
              Câmara Municipal de Bela Cruz
            </h1>
            <Divider className="bg-amber-300 my-2 h-[8px] " />
            <p className="text-3xl font-sans  text-gray-50 uppercase">
              {/* @ts-ignore */}
              {sessao.sessao} SESSÃO{" "}
              {sessao.tipoSessao === "extraordinaria"
                ? "EXTRAORDINÁRIA"
                : "ORDINÁRIA"}{" "}
              {sessao.periodo === undefined
                ? ""
                : sessao.periodo === "1"
                ? "DO 1° PERÍODO DA LEGISLATURA"
                : "DO 2° PERÍODO DA LEGISLATURA"}{" "}
              ({sessao.legislatura})
            </p>
          </CardHeader>
        </Card>
      </div>

      <div className="w-full flex justify-between p-0 ">
        <div className="w-1/2">
          <Table hideHeader fullWidth className="p-0">
            <TableHeader>
              <TableColumn>Nome</TableColumn>
            </TableHeader>
            <TableBody>
              {/* @ts-ignore */}
              {mesaDiretora
                .sort(
                  (a, b) =>
                    //@ts-ignore
                    (ORDEM_MESA_DIRETORA[funcaoPorId[a.id]] ?? -1) -
                    //@ts-ignore
                    (ORDEM_MESA_DIRETORA[funcaoPorId[b.id]] ?? -1)
                )
                .map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      borderTopColor: "#1F273A",
                      borderTopWidth: index === 0 ? 0 : 2,
                    }}
                  >
                    <TableCell
                      style={{
                        height: 70,
                      }}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                          <div className="w-10 h-10 border border-white rounded-full p-1">
                            {
                              //@ts-ignore
                              (item as any).presenca === true && (
                                <div className="w-full h-full bg-blue-400 rounded-full" />
                              )
                            }
                          </div>

                          <p
                            className={`text-2xl font-extrabold uppercase text-yellow-400 `}
                          >
                            {
                              //@ts-ignore
                              LABEL_MESA_DIRETORA[funcaoPorId[item.id]]
                            }
                          </p>

                          <p
                            className={`text-2xl font-extrabold uppercase ${
                              (item as any).presenca === true
                                ? "text-blue-400"
                                : "text-blue-400"
                            } ${
                              (item as any).presenca === true
                                ? "opacity-100"
                                : "opacity-25"
                            }`}
                          >
                            {/* @ts-ignore */}
                            {item.nome}
                          </p>
                        </div>

                        <p
                          className={`text-2xl font-extrabold uppercase ${
                            (item as any).presenca === true
                              ? "text-blue-400"
                              : "text-blue-400"
                          } ${
                            (item as any).presenca === true
                              ? "opacity-100"
                              : "opacity-25"
                          }`}
                        >
                          {/* @ts-ignore */}
                          {item.partido}
                        </p>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>

          <Divider className="bg-amber-300 my-[15px] h-[8px] " />

          <Table hideHeader fullWidth className="p-0 ">
            <TableHeader>
              <TableColumn>Nome</TableColumn>
            </TableHeader>
            <TableBody>
              {primeiraParte.map((item, index) => (
                <TableRow
                  key={index}
                  style={{
                    borderTopColor: "#1F273A",
                    borderTopWidth: index === 0 ? 0 : 2,
                  }}
                >
                  <TableCell
                    style={{
                      height: 70,
                    }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-10 h-10 border border-white rounded-full p-1">
                          {
                            //@ts-ignore
                            (item as any).presenca === true && (
                              <div className="w-full h-full bg-blue-400 rounded-full" />
                            )
                          }
                        </div>
                        <p
                          className={`text-2xl font-extrabold uppercase ${
                            (item as any).presenca === true
                              ? "text-blue-400"
                              : "text-blue-400"
                          } ${
                            (item as any).presenca === true
                              ? "opacity-100"
                              : "opacity-25"
                          }`}
                        >
                          {/* @ts-ignore */}
                          {item.nome}
                        </p>
                      </div>

                      <p
                        className={`text-2xl font-extrabold uppercase ${
                          (item as any).presenca === true
                            ? "text-blue-400"
                            : "text-blue-400"
                        } ${
                          (item as any).presenca === true
                            ? "opacity-100"
                            : "opacity-25"
                        }`}
                      >
                        {/* @ts-ignore */}
                        {item.partido}
                      </p>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        {/* Tabela 2 */}
        <div className="w-1/2">
          <Table hideHeader fullWidth>
            <TableHeader>
              <TableColumn>Nome</TableColumn>
            </TableHeader>
            <TableBody>
              {segundaParte.map((item, index) => (
                <TableRow
                  key={index}
                  style={{
                    borderTopColor: "#1F273A",
                    borderTopWidth: index === 0 ? 0 : 2,
                  }}
                >
                  <TableCell
                    style={{
                      height: 70,
                    }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-10 h-10 border border-white rounded-full p-1">
                          {
                            //@ts-ignore
                            (item as any).presenca === true && (
                              <div className="w-full h-full bg-blue-400 rounded-full" />
                            )
                          }
                        </div>
                        <p
                          className={`text-2xl font-extrabold uppercase ${
                            (item as any).presenca === true
                              ? "text-blue-400"
                              : "text-blue-400"
                          } ${
                            (item as any).presenca === true
                              ? "opacity-100"
                              : "opacity-25"
                          }`}
                        >
                          {/* @ts-ignore */}
                          {item.nome}
                        </p>
                      </div>

                      <p
                        className={`text-2xl font-extrabold uppercase ${
                          (item as any).presenca === true
                            ? "text-blue-400"
                            : "text-blue-400"
                        } ${
                          (item as any).presenca === true
                            ? "opacity-100"
                            : "opacity-25"
                        }`}
                      >
                        {/* @ts-ignore */}
                        {item.partido}
                      </p>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>

      <div>
        <Divider className="bg-gray-700 h-[18px]" />

        <div className="grid h-full w-full grid-cols-3 ">
          <div className="flex flex-col h-full">
            <div className="p-1 border-1 border-gray-700 h-full text-5xl text-center font-bold text-gray-50">
              {format(new Date(), "HH:mm:ss")}
            </div>
            <div className="p-1 border-1 border-gray-700 h-full text-2xl text-center font-normal text-gray-50">
              {format(new Date(), "dd/MM/yyyy")}
            </div>
          </div>

          <div className="flex h-full w-full flex-row justify-between">
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                SIM
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full w-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                NÃO
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                ABST
              </div>
            </div>
          </div>

          <div className=" h-full w-full flex flex-col justify-between">
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-white">
              <span className="text-2xl font-semibold ">PARLAMENTARES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length}
              </span>
            </div>
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-red-500">
              <span className="text-2xl font-semibold ">AUSENTES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length -
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length}
              </span>
            </div>
            <div className="p-1 h-full w-full flex flex-row justify-between px-16 border-1 border-slate-600 text-2xl text-center font-normal text-blue-400">
              <span className="text-2xl font-bold ">PRESENTES</span>
              <span className="text-2xl font-bold ">
                {
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
